<template>
  <v-dialog
    v-model="isOpen"
    @keydown.esc="close"
    persistent
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">New page from template</span>
      </v-card-title>

      <v-tabs centered>
        <v-tab
          v-for="item in dialogTabs"
          :id="item.value.toLowerCase()"
          :key="item.value"
          class="font-size-sub"
          v-on:click="onChangeTab(item)"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>

      <v-card-text>
        <v-container>
          <v-row v-if="currentTab === 'general'">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-data-table
                :loading="loading"
                :headers="headersGeneralTemplate"
                :items="generalTemplates"
                :items-per-page="9999"
                hide-default-footer
                fixed-header
                must-sort
                class="elevation-1"
              >
                <template v-slot:item="props">
                  <tr
                    v-on:click="rowClick(props.item.flow_template_id)"
                    :class="
                      `cursor-pointer ${
                        idSelected === props.item.flow_template_id
                          ? 'font-weight-bold'
                          : ''
                      }
                    `
                    "
                  >
                    <td>{{ props.item.name }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row v-if="currentTab === 'my template'">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-data-table
                :loading="loading"
                :headers="headersMyTemplate"
                :items="myTemplates"
                :items-per-page="9999"
                hide-default-footer
                fixed-header
                must-sort
                class="elevation-1"
              >
                <template v-slot:item="props">
                  <tr
                    v-on:click="rowClick(props.item.flow_template_id)"
                    class="cursor-pointer"
                  >
                    <td>
                      <div v-if="props.item.isEdit">
                        <v-text-field
                          :ref="
                            `inputFlowName-${myTemplates.indexOf(props.item)}`
                          "
                          v-model="editedItem.name"
                          @blur="
                            cancelRenameFlowTemplate(
                              myTemplates.indexOf(props.item)
                            )
                          "
                          @keydown.enter="
                            renameFlowTemplate(myTemplates.indexOf(props.item))
                          "
                        ></v-text-field>
                      </div>
                      <div
                        v-else
                        :class="
                          `${
                            idSelected === props.item.flow_template_id
                              ? 'font-weight-bold'
                              : ''
                          }`
                        "
                      >
                        {{ props.item.name }}
                      </div>
                    </td>
                    <td class="text-center">
                      <v-icon
                        small
                        @click.stop="editItem(myTemplates.indexOf(props.item))"
                      >
                        fa-edit
                      </v-icon>
                      <v-icon
                        class="m-l-10"
                        small
                        @click.stop="deleteItem(props.item)"
                      >
                        fa-trash
                      </v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <div id="error" class="red--text text-center">
        {{ errorMessage }}
      </div>

      <v-divider></v-divider>

      <v-card-actions class="v-card-action-padding m-t-15">
        <v-spacer></v-spacer>
        <v-btn class="btn-secondary" @click="close">
          Cancel
        </v-btn>
        <v-btn
          id="btn-ok"
          class="btn-primary"
          :disabled="!idSelected"
          @click="save"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import apiFlowTemplate from '@/apis/flow_template'

export default {
  name: 'DialogTemplate',
  props: {
    isOpen: Boolean,
    data: Object,
    tabs: Array,
    errorMessage: String
  },
  data() {
    return {
      loading: false,
      currentTab: 'general',
      dialogTabs: [
        { label: 'general', value: 'general' },
        { label: 'my templates', value: 'my template' }
      ],
      headersGeneralTemplate: [
        {
          text: 'Template',
          align: 'start',
          sortable: false,
          value: 'name'
        }
      ],
      headersMyTemplate: [
        {
          text: 'Template',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'center',
          width: '100px'
        }
      ],
      generalTemplates: [],
      myTemplates: [],
      editedItem: {
        flow_template_id: '',
        name: ''
      },
      idSelected: ''
    }
  },
  created() {
    this.getFlowTemplates()
  },
  methods: {
    async getFlowTemplates() {
      try {
        const flowTemplates = await apiFlowTemplate.getFlowTemplates()
        this.generalTemplates = flowTemplates.data.filter(
          item => item.type === this.dialogTabs[0].value
        )
        this.myTemplates = flowTemplates.data
          .filter(item => item.type === this.dialogTabs[1].value)
          .map(item => ({ ...item, isEdit: false }))
      } catch (error) {
        // console.log(error)
      }
    },

    onChangeTab(tab) {
      this.currentTab = tab.value
      this.idSelected = ''
      // this.getFlowTemplates()
    },

    rowClick(id) {
      this.idSelected = id
    },

    editItem(index) {
      this.myTemplates[index].isEdit = true
      setTimeout(() => {
        this.$refs[`inputFlowName-${index}`].focus()
      }, 200)
      this.editedItem = this.myTemplates[index]
    },

    async renameFlowTemplate(index) {
      try {
        this.myTemplates[index].isEdit = true

        const { flow_template_id, name } = this.editedItem
        this.isEdit = false
        if (!name) {
          this.errorMessage = 'Template name is required'
          return false
        }

        const obj = {
          name: name.trim()
        }
        await apiFlowTemplate.renameFlowTemplate(flow_template_id, obj)
        this.getFlowTemplates()
        this.errorMessage = ''
      } catch (error) {
        this.errorMessage = error.message
      }
    },

    cancelRenameFlowTemplate(index) {
      this.myTemplates[index].isEdit = false
      this.getFlowTemplates()
    },

    save() {
      this.$emit('save', { ...this.data, idSelected: this.idSelected })
    },

    deleteItem(item) {
      const { flow_template_id, name } = item
      const obj = { id: flow_template_id, name: name }
      this.$emit('delete', obj)
    },

    close() {
      this.$emit('close', null)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-data-table__wrapper {
  height: calc(70vh - 250px);
}
</style>
